import BannerImg from '../../assets/space-motors-picture.png';

const Banner = () => <img src={BannerImg} alt="Banner" />;

export default Banner;
